<template lang="pug">
  .loading(:style="'height: ' + height + 'px; line-height: ' + height + 'px;'")
    b-spinner
</template>

<script>

export default {
  /* eslint-disable */
  name: 'Loading',
  props: {
    height: { type: Number, required: false, default: 450 }
  }
}
</script>

<style scoped>
.loading {
  text-align: center;
}
</style>
